import React from 'react'
import { SearchDropdown, HighlightedText } from '@ui'
import { IAssetsHook } from './hooks/useAssets'
import { NavigateFn } from '@reach/router'
import useAssetTagSearch from './hooks/useAssetTagSearch'
import track from '@track'

export default function AssetSearch({
  hook,
  navigate,
}: {
  hook: IAssetsHook
  navigate?: NavigateFn
}) {
  const { run, items, query, loading } = useAssetTagSearch()
  return (
    <SearchDropdown
      width={'300px'}
      search={{ run, items, query, loading }}
      onSelect={(asset) => {
        if (!asset) return undefined
        navigate?.(`?assetId=${asset.id}`)
        track.assets({
          eventName: track.Event.SEARCH_RESULT_CLICK,
        })
      }}
      renderItem={(asset) => <HighlightedText text={asset.name} query={query} />}
      queryTable={(string) => hook.search(string)}
    />
  )
}
